module.exports = __webpack_public_path__ + "img/add_circle_outline.8a0903ca.svg";